import { useLocation, useNavigate } from "react-router";
import { Iframe } from "@medoma/components/Iframe/Iframe";
import { useEffect, useState } from "react";
import { useLingui } from "@lingui/react/macro";
import { getPatientApiUrl } from "@/utils/envUtils";
import { useUserProfile } from "@/utils/useUserProfile";

export const Measurements = () => {
  const { search } = useLocation();
  const measurementsChooserQueryString = search === "" ? "" : `/add${search}`;
  const navigate = useNavigate();
  const { t } = useLingui();
  const { organization } = useUserProfile();

  const postMessageHandler = {
    messageType: "cancelMeasurementsForm",
    onMessageReceived: () => {
      void navigate("..");
    },
  };

  const [iframeKey, setIframeKey] = useState(0);
  useEffect(() => {
    const reloadIframe = () => {
      setIframeKey((prevKey) => prevKey + 1);
    };

    window.addEventListener("visibilitychange", reloadIframe);
    return () => {
      window.removeEventListener("visibilitychange", reloadIframe);
    };
  }, []);

  return (
    <div style={{ position: "absolute", inset: 0 }}>
      <Iframe
        title={t`Mätvärden`}
        src={`${getPatientApiUrl(organization)}/htmx/measurements${measurementsChooserQueryString}`}
        loadingMessage={t`Hämtar mätvärden`}
        postMessageHandler={postMessageHandler}
        key={iframeKey}
      />
    </div>
  );
};
